(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/helpers/handlebarshelpers.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/helpers/handlebarshelpers.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function () {
  'use strict';

  var trinidad;

  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    trinidad = require('trinidad-core').core; 

    registerHelpers(require('hbs'), trinidad.components.require('libs', 'moment').moment, require('underscore'));
  } else {
    registerHelpers(Handlebars, moment, _);
  }

  function registerHelpers(hbs) {
    hbs.registerHelper('stringify', function (obj) {
      return obj && JSON.stringify(obj);
    });
  }
})();
 })(window);